<apx-chart
  [series]="properties.series"
  [chart]="properties.chart"
  [dataLabels]="properties.dataLabels"
  [yaxis]="properties.yaxis"
  [legend]="properties.legend"
  [fill]="properties.fill"
  [stroke]="properties.stroke"
  [tooltip]="properties.tooltip"
  [xaxis]="properties.xaxis"
  [colors]="properties.colors"
  [title]="properties.title"
></apx-chart>